export default function videoHero($element, videoHero) {
    if (!$element || !videoHero || !window.matchMedia('screen and (min-width: 768px)').matches || !videoHero.sources.length) {
        return;
    }

    const $video = document.createElement('video');

    $video.poster = videoHero.poster;

    videoHero.sources.forEach(source => {
        const $source = document.createElement('source');

        $source.src = `${source.File.Url}?w=1280`;
        $source.type = source.File.ContentType;

        $video.append($source);
    });

    $element.classList.add('video');
    $element.append($video);

    $video.controls = true;
    $video.muted = true;
    $video.playsinline = true;
    $video.loop = true;
    $video.autoplay = true;
}